module.exports = "body .sooneat-login-wrapper {\n  background-color: #fff; }\n\n.justify-content {\n  justify-content: center; }\n"